<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Pay NCC</h2>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <button
        class="ui small button primary"
        (click)="collapsePaymentStatus = !collapsePaymentStatus"
      >
        Check Payment Status
      </button>
    </div>
  </div>
  <div
    class="ui basic segment"
    [suiCollapse]="collapsePaymentStatus"
    style="padding: 0"
  >
    <div
      class="ui basic segment"
      appPadding
      paddingL="50px"
      fxLayout="row"
      fxLayoutGap="20px"
    >
      <div class="ui form" fxFlex="60%" [ngClass]="{ loading: pending }">
        <div class="fields">
          <div class="twelve wide field">
            <label id="tertiary"
              >REMITA RETRIEVAL REFERENCE (RRR)/Transaction Reference</label
            >
            <input
              type="text"
              [formControl]="paymentField"
              placeholder="Enter RRR/Transaction Reference"
            />
          </div>
          <div class="four field">
            <label>&nbsp;</label>
            <button type="submit" class="ui primary button" (click)="submit()">
              Submit
            </button>
          </div>
        </div>
      </div>
      <div fxFlex="30%" fxLayout="column" fxLayoutGap="10px" *ngIf="paymentIRR">
        <div fxFlex>
          <span style="color: #bbbbc0"><strong>AMOUNT</strong></span>
          <h2 class="ui primary header">
            {{ paymentIRR?.currencyCode }}
            {{ paymentIRR?.amount | number: ".2-2" }}
          </h2>
        </div>
        <div appMargin marginB="10px">
          <span style="color: #bbbbc0"><strong>PAYMENT STATUS</strong></span>
          <div>
            <span
              class="ui label"
              [ngClass]="{
                red: paymentIRR.status == 'UNPAID',
                green: paymentIRR.status == 'PAID'
              }"
              >{{ paymentIRR?.status }}</span
            >
          </div>
        </div>
        <div fxFlex *ngIf="paymentIRR.status == 'AWAITING_PAYMENT'">
          <button
            class="ui primary button"
            (click)="goToPayment(paymentIRR)"
            *ngIf="paymentIRR.currencyCode == '₦'"
            target="_blank"
          >
            Pay Now
          </button>
          <a
            class="ui primary button"
            href="{{ paymentIRR.paymentUrl }}"
            *ngIf="paymentIRR.currencyCode != '₦'"
            target="_blank"
            >Upload Proof of Payment</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="ui divider" appMargin marginY="3"></div>

<div *ngIf="successMsg || errorMsg" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="successMsg"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="errorMsg"></esl-message-toast>
</div>

<div class="ui tertiary segment">
  <div>
    Pay for a service by clicking on the Pay button next to the service. If you
    have an E-Services account, please login to enable you see all your
    transactions and records with NCC in one place.
  </div>
</div>

<div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
  <ng-template #recursiveList let-arrangements>
    <div *ngFor="let item of arrangements">
      <div
        class="ui segment"
        fxLayout="row wrap"
        fxLayoutAlign="space-between center"
        appPadding
        paddingB="3"
        appMargin
        marginY="5"
        id="section"
      >
        <div fxFlex>
          {{ item.revenueService?.categoryName }}
        </div>
        <div>
          <button
            class="ui button"
            *ngIf="
              item.children &&
              item.children.length < 1 &&
              item.revenueService.requireInvoiceNo
            "
          >
            Requires Invoice Number
          </button>
          <button
            *ngIf="item.children && item.children.length > 0"
            class="ui grey button"
            (click)="item.collapse = !item.collapse"
          >
            {{ item.collapse == true ? "UnSelect" : "Select" }}
          </button>
          <button
            *ngIf="item.children && item.children.length < 1"
            class="ui primary button"
            (click)="pay(item)"
          >
            Pay
          </button>
        </div>
      </div>
      <div
        *ngIf="item.children && item.children.length > 0"
        [suiCollapse]="!item.collapse"
      >
        <div style="margin-left: 20px">
          <ng-container
            *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: item.children }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container
    *ngTemplateOutlet="recursiveList; context: { $implicit: arrangements }"
  ></ng-container>
</div>

<!-- </div> -->
